import { proxyApi } from "./index";
/**
 * 员工 的代理接口
 * @description 系统员工模块的暴露接口
 * @export
 * @param {string} target 请求路由
 * @param {*} [data] 请求参数
 */
export function staffApi(target, data) {
    return proxyApi({ module: 'staff', target, data });
}
/**
 * 查询openid绑定的员工信息
 * @deprecated 使用`loginInfo`获取带限制的员工信息
 * @description 多个员工信息返回第1条
 */
export function getStaffInfo() {
    return staffApi('info');
}
/**
 * 查询登录的员工信息
 * loginInfo 的会去判断 员工的状态，如果被锁定的话，就不返回了
 */
export function getLoginStaffInfo() {
    return staffApi('loginInfo');
}
/**
 * 验证返回的状态码
 * @description 登录配置如果没有设置 使用 `手机验证码`或者`邮箱验证码`的话 就会1
 * @export
 * @enum {string}
 */
export var SendVaildCodeStatus;
(function (SendVaildCodeStatus) {
    /** 成功 */
    SendVaildCodeStatus["Ok"] = "0";
    /** 无需验证 */
    SendVaildCodeStatus["NoNeed"] = "1";
    /** 多次触发，稍后再试 */
    SendVaildCodeStatus["TryAgainLater"] = "2";
})(SendVaildCodeStatus || (SendVaildCodeStatus = {}));
/**
 * 获取登录验证码
 * @description 选择邮箱或者手机验证
 * @param {{ type: StaffValidType, mailbox?: string, phone?: string }} params
 */
export function getStaffValidCode(params) {
    return staffApi('validCode', params);
}
/**
 * 登录返回的状态码
 * @enum {string}
 */
export var StaffLoginStatus;
(function (StaffLoginStatus) {
    StaffLoginStatus["Error"] = "-1";
    StaffLoginStatus["Ok"] = "200";
    StaffLoginStatus["NotFoundStaff"] = "404";
    StaffLoginStatus["ErrorPhoneValidCode"] = "409";
    StaffLoginStatus["ErrorMailboxValidCode"] = "410";
})(StaffLoginStatus || (StaffLoginStatus = {}));
/**
 * 员工登录
 * @description 使用短信或者邮件验证码进行登录;
 * 登录会有一个绑定的过程，如果之前你的手机号和openid 没有绑定的话，就会再登录完成之后进行绑定
 * @param {{ mailbox?: string, phone?: string, mailboxValidCode?: string, phoneValidCode?: string }} params
 */
export function loginWithStaff(params) {
    return staffApi('login', params);
}
